
import React, { useState, useEffect, useRef } from "react";
import '../css/MainPage.css';

export const Main = ({ setIsHeaderVisible }) => {
  const [isTest001Visible, setIsTest001Visible] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    const introSeen = localStorage.getItem('introSeen');
    if (introSeen === 'true') {
      setIsTest001Visible(false);
    }
  }, []);

  const handleScroll = () => {
    if (scrollRef.current) {
      const position = scrollRef.current.scrollTop;
      if (position > 2000 && isTest001Visible) {
        setIsTest001Visible(false);
        localStorage.setItem('introSeen', 'true');
        setIsHeaderVisible(true);
      }
    }
  };

  useEffect(() => {
    const scrollableElement = scrollRef.current;
    if (scrollableElement) {
      scrollableElement.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isTest001Visible]);

  useEffect(() => {
    if (isTest001Visible) {
      document.body.style.overflowX = 'hidden';
      document.body.style.overflowY = 'hidden';
      document.body.classList.add('scroll-event-active');
      setIsHeaderVisible(false);
    } else {
      document.body.style.overflowX = 'hidden';
      document.body.style.overflowY = 'auto';
      document.body.classList.remove('scroll-event-active');
      setIsHeaderVisible(true);
    }
  }, [isTest001Visible, setIsHeaderVisible]);


  const Skill = ({ name, icon }) => {
    const [isLiked, setIsLiked] = useState(false);

    const handleSkillClick = () => {
      setIsLiked(!isLiked);
    };

    return (
      <div className="skills" onClick={handleSkillClick}>
        {icon}
        <span>{name}</span>
        <button className="material-symbols-outlined skillsIcon">
          {isLiked ? 'thumb_up' : 'check'}
        </button>
      </div>
    );
  };

  return (
    <div className={isTest001Visible ? "scroll" : "noScroll"} ref={scrollRef}>
      {isTest001Visible && (
        <div className="ScrollEvent">
          <div className="introSection">
            <h1>안녕하세요, <span className="highlight">김선익</span>입니다.</h1>
            <div className="subs">
              <h2>열정과 도전</h2>
              <p>"새로운 기술에 대한 끝없는 호기심과 열정으로 항상 다음 도전을 준비합니다. 변화하는 소프트웨어 개발 세계에서 매일 성장하고 문제 해결에 큰 기쁨을 느낍니다."</p>
            </div>
            <div className="subs">
              <h2>학습과 성장</h2>
              <p>"지식에는 끝이 없습니다. 소프트웨어 공학을 전공하며 쌓은 이론적 기반 위에 실무 경험을 더해왔습니다. 새로운 기술을 배우고 최신 트렌드를 따라잡는 것은 저의 즐거움입니다."</p>
            </div>
            <div className="subs">
              <h2>전문성과 혁신</h2>
              <p>"CCTV 실시간 객체 탐지, 카리프트 알고리즘 개발, ERP 서비스 구축 등 다양한 프로젝트를 통해 전문성과 문제 해결 능력을 키워왔습니다. 각 프로젝트는 저에게 귀중한 배움의 기회였습니다."</p>
            </div>
            <div className="subs">
              <h2>팀워크와 협력</h2>
              <p>"혼자서는 빠르게 갈 수 있지만 함께라면 더 멀리 갈 수 있습니다. 다양한 사람들과의 협업을 통해 더 나은 결과를 추구하며 팀워크와 소통을 중시합니다."</p>
            </div>
            <div className="subs">
              <h2>미래 지향적 비전</h2>
              <p>"기술은 미래를 만듭니다. 저는 기술이 사람들의 삶을 어떻게 변화시킬 수 있는지 깊이 고민하며 긍정적인 영향을 미치는 코드를 작성하고자 합니다. 지속 가능한 혁신을 통해 더 나은 미래를 만들어가겠습니다."</p>
            </div>
            <p className="start">이제 <span className="highlight">시작</span>합니다.</p>
          </div>
          <span className="material-symbols-outlined icon2">
            keyboard_double_arrow_down
          </span>
        </div>
      )}
      {!isTest001Visible && (
        <div className="Main-Wrap">

          <div className="top">
            <div className="bgimg"></div>

          </div>
          <div className="bar">
            <h3 className="ItemTitle">My Skills</h3><br />
            {/* <BarChart /> */}
            <div className="SkillsWrap">
            <Skill
                name="HTML5"
                icon={
                  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>HTML5</title><path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.564-2.438L1.5 0zm7.031 9.75l-.232-2.718 10.059.003.23-2.622L5.412 4.41l.698 8.01h9.126l-.326 3.426-2.91.804-2.955-.81-.188-2.11H6.248l.33 4.171L12 19.351l5.379-1.443.744-8.157H8.531z" /></svg>
                }
              />
            <Skill
                name="CSS3"
                icon={
                  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>CSS3</title><path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.565-2.438L1.5 0zm17.09 4.413L5.41 4.41l.213 2.622 10.125.002-.255 2.716h-6.64l.24 2.573h6.182l-.366 3.523-2.91.804-2.956-.81-.188-2.11h-2.61l.29 3.855L12 19.288l5.373-1.53L18.59 4.414z" /></svg>
                }
              />
            <Skill
                name="ReactJS"
                icon={
                <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>ReactJS</title><path d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z" /></svg>
              }
              />
            <Skill
                name="Firebase"
                icon={
<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Firebase</title><path d="M19.455 8.369c-.538-.748-1.778-2.285-3.681-4.569-.826-.991-1.535-1.832-1.884-2.245a146 146 0 0 0-.488-.576l-.207-.245-.113-.133-.022-.032-.01-.005L12.57 0l-.609.488c-1.555 1.246-2.828 2.851-3.681 4.64-.523 1.064-.864 2.105-1.043 3.176-.047.241-.088.489-.121.738-.209-.017-.421-.028-.632-.033-.018-.001-.035-.002-.059-.003a7.46 7.46 0 0 0-2.28.274l-.317.089-.163.286c-.765 1.342-1.198 2.869-1.252 4.416-.07 2.01.477 3.954 1.583 5.625 1.082 1.633 2.61 2.882 4.42 3.611l.236.095.071.025.003-.001a9.59 9.59 0 0 0 2.941.568q.171.006.342.006c1.273 0 2.513-.249 3.69-.742l.008.004.313-.145a9.63 9.63 0 0 0 3.927-3.335c1.01-1.49 1.577-3.234 1.641-5.042.075-2.161-.643-4.304-2.133-6.371m-7.083 6.695c.328 1.244.264 2.44-.191 3.558-1.135-1.12-1.967-2.352-2.475-3.665-.543-1.404-.87-2.74-.974-3.975.48.157.922.366 1.315.622 1.132.737 1.914 1.902 2.325 3.461zm.207 6.022c.482.368.99.712 1.513 1.028-.771.21-1.565.302-2.369.273a8 8 0 0 1-.373-.022c.458-.394.869-.823 1.228-1.279zm1.347-6.431c-.516-1.957-1.527-3.437-3.002-4.398-.647-.421-1.385-.741-2.194-.95.011-.134.026-.268.043-.4.014-.113.03-.216.046-.313.133-.689.332-1.37.589-2.025.099-.25.206-.499.321-.74l.004-.008c.177-.358.376-.719.61-1.105l.092-.152-.003-.001c.544-.851 1.197-1.627 1.942-2.311l.288.341c.672.796 1.304 1.548 1.878 2.237 1.291 1.549 2.966 3.583 3.612 4.48 1.277 1.771 1.893 3.579 1.83 5.375-.049 1.395-.461 2.755-1.195 3.933-.694 1.116-1.661 2.05-2.8 2.708-.636-.318-1.559-.839-2.539-1.599.79-1.575.952-3.28.479-5.072zm-2.575 5.397c-.725.939-1.587 1.55-2.09 1.856-.081-.029-.163-.06-.243-.093l-.065-.026c-1.49-.616-2.747-1.656-3.635-3.01-.907-1.384-1.356-2.993-1.298-4.653.041-1.19.338-2.327.882-3.379.316-.07.638-.114.96-.131l.084-.002c.162-.003.324-.003.478 0 .227.011.454.035.677.07.073 1.513.445 3.145 1.105 4.852.637 1.644 1.694 3.162 3.144 4.515z" /></svg>
                }
              />
            <Skill
                name="GitHub"
                icon={
                  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>GitHub</title><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" /></svg>
                }
              />
            <Skill
                name="C++"
                icon={
                  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>C++</title><path d="M22.394 6c-.167-.29-.398-.543-.652-.69L12.926.22c-.509-.294-1.34-.294-1.848 0L2.26 5.31c-.508.293-.923 1.013-.923 1.6v10.18c0 .294.104.62.271.91.167.29.398.543.652.69l8.816 5.09c.508.293 1.34.293 1.848 0l8.816-5.09c.254-.147.485-.4.652-.69.167-.29.27-.616.27-.91V6.91c.003-.294-.1-.62-.268-.91zM12 19.11c-3.92 0-7.109-3.19-7.109-7.11 0-3.92 3.19-7.11 7.11-7.11a7.133 7.133 0 016.156 3.553l-3.076 1.78a3.567 3.567 0 00-3.08-1.78A3.56 3.56 0 008.444 12 3.56 3.56 0 0012 15.555a3.57 3.57 0 003.08-1.778l3.078 1.78A7.135 7.135 0 0112 19.11zm7.11-6.715h-.79v.79h-.79v-.79h-.79v-.79h.79v-.79h.79v.79h.79zm2.962 0h-.79v.79h-.79v-.79h-.79v-.79h.79v-.79h.79v.79h.79z" /></svg>
                }
              />
     
            </div>

          </div>
          <div className="Items_Wrap">

            <div className="Introduce">
              <div className="flx">
                <h3 className="ItemTitle">자기소개</h3>
              </div>
              <div className="ItemContents">

                안녕하세요, 김선익입니다.<br />
                저는 어릴 때부터 컴퓨터와 소프트웨어 개발에 관심을 가지고 성장했으며<br />
                대학에서 소프트웨어 공학을 전공했습니다.<br />
                졸업 후 사무직 경험과 전산응용 기계제도 기능사 자격증을 통해<br />
                엔지니어링 역량을 키웠고<br />
                개발 팀으로 이직해 C, C++로 CCTV 실시간 객체 탐지와<br />
                카리프트 알고리즘을 개발했습니다.<br />
                React를 사용해 ERP 서비스를 개발한 경험이 있으며<br />
                다양한 경험을 통해 문제 해결 능력과 팀 협업 능력을 키웠고<br />
                빠르게 변화하는 환경에 적응하며 기술을 향상시켰습니다.<br />
                새로운 도전을 즐기고 혁신적인 프로젝트를 주도하고자 합니다.<br />
                감사합니다!
              </div>
            </div>
            <div className="ItemGroup">
              <div className="Item">
                <div className="flx">
                  <span className="material-symbols-outlined icon1">
                    workspace_premium
                  </span>
                  <h3 className="ItemTitle">자격증</h3>
                </div>
                <div className="Certifications-Wrap">
                  <div className="Certifications">
                    <span className="certifi_name" title="전산응용기계제도 기능사">전산응용기계제도 기능사</span>
                    <span className="certifi_day">2022.04</span>
                  </div>
                  <div className="Certifications">
                    <span className="certifi_name" title="컴퓨터활용능력 2급">컴퓨터활용능력 2급</span>
                    <span className="certifi_day">2013.12</span>
                  </div>
                  <div className="Certifications">
                    <span className="certifi_name" title="워드프로세서">워드프로세서</span>
                    <span className="certifi_day">2013.12</span>
                  </div>
                  <div className="Certifications">
                    <span className="certifi_name" title="ITQ OA 마스터">ITQ OA 마스터</span>
                    <span className="certifi_day">2013.12</span>
                  </div>
                  <div className="Certifications">
                    <span className="certifi_name" title="1종보통 운전면허">1종보통 운전면허</span>
                    <span className="certifi_day">2013.12</span>
                  </div>
                </div>
              </div>
              <div className="Item">
                <div className="flx">
                  <span className="material-symbols-outlined icon1">code</span>
                  <h3 className="ItemTitle">개발 경험</h3>
                </div>
                <span className="Certifications-Wrap">C언어
                  <div className="Certifications">CCTV를 활용한 실시간 객체 탐지</div>
                  <div className="Certifications">카리프트 알고리즘</div>
                  <div className="Certifications">React</div>
                  사내 ERP서비스</span>
              </div>
              <div className="Item">
                <div className="flx">
                  <span className="material-symbols-outlined icon1">lightbulb</span>
                  <h3 className="ItemTitle">개발 철학</h3>
                </div>
                <span className="Certifications-Wrap">
                  <div className="Certifications">1. 사용자 중심</div>
                  <div className="Certifications">2. 사용자의 편리함</div>
                  <div className="Certifications">3. 사용자의 직관성</div>
                </span>
              </div>
            </div>
            {/* <div className="Link-Wrap">
              <Link to="/webgame" className="Item WithBtn">
                <h3 className="ItemTitle">웹 게임</h3>
                <span className="ItemContents">캔버스를 활용한 간단한 게임</span>
              </Link>
              <Link to="/weather" className="Item WithBtn">
                <h3 className="ItemTitle">날씨 정보</h3>
                <span className="ItemContents">openweather API를 활용한 기상 웹</span>
              </Link>
              <Link to="/pokemon" className="Item WithBtn">
                <h3 className="ItemTitle">포켓몬 도감</h3>
                <span className="ItemContents">포켓몬 API를 활용한 도감 웹</span>
              </Link>
              <Link to="/erp/login" className="Item WithBtn" target="_blank">
                <h3 className="ItemTitle">ERP 시스템</h3>
                <span className="ItemContents">사내에 필요한 다양한 기능을 제공하는 ERP</span>
              </Link>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
}
